module.exports = __webpack_public_path__ + "img/email1.bf34d660.svg";